// extracted by mini-css-extract-plugin
export var p = "ProductReference-module--p--2D6VR";
export var title = "ProductReference-module--title--3f64k";